import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-epf-form',
  templateUrl: './epf-form.component.html',
  styleUrls: ['./epf-form.component.css']
})
export class EpfFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/organisation-profile/epf/epf-form/epf-form.component.ts